import { render, staticRenderFns } from "./home-common-link.vue?vue&type=template&id=7a547dd6&scoped=true&"
import script from "./home-common-link.vue?vue&type=script&lang=js&"
export * from "./home-common-link.vue?vue&type=script&lang=js&"
import style0 from "./home-common-link.vue?vue&type=style&index=0&id=7a547dd6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a547dd6",
  null
  
)

export default component.exports